/**
 * 商家-导出履约信息
 */
export const downloadSupplyFulfill = (params) => {
  return window._this.$http.post("/erp/SupplyPerform/exportPerform", params);
};
/**
 * 商家-履约信息获取
 */
export const getSupplyFulfillDetail = (params) => {
  return window._this.$http.get("/erp/SupplyPerform/getPerform", {
    params,
  });
};
/**
 * 商家-履约信息保存
 */
export const saveSupplyFulfillDetail = (params) => {
  return window._this.$http.post("/erp/SupplyPerform/savePerform", params);
};
/**
 * 商家-履约信息保存日志
 */
export const getSupplyFulfillLog = (params) => {
  return window._this.$http.get("/erp/SupplyPerform/getPerformLog", {
    params,
  });
};



// WEBPACK FOOTER //
// ./src/api/supply.js